<template>
  <div id="job">
    <template v-for="(item, index) in list">
      <div class="list-item" :key="item.title">
        <div
          @click="changItemShow(index)"
          class="item-title"
          v-show="!item.isShow"
        >
          <h3>{{ item.name }}</h3>
          <img src="../../assets/image/arr_down.png" alt="" />
        </div>
        <div class="item-box" v-show="item.isShow">
          <div class="box-top" @click="changItemShow(index)">
            <h3>{{ item.name }}</h3>
            <img src="../../assets/image/arr_up.png" alt="" />
          </div>
          <template v-for="job in item.jobList">
            <div :key="job.job_id" class="job-info">
              <h4>职位名称：{{ job.name }}</h4>
              <p class="marg-b-5">发布时间：{{ job.updated_at }}</p>
              <p class="time">招聘人数：{{ job.number }}人</p>
              <div class="jobDesc">
                <h5>岗位职责</h5>
                <ul>
                  <li v-for="duty in job.dutyList" :key="duty">
                    {{ duty }}
                  </li>
                </ul>
              </div>
              <div class="jobDesc">
                <h5>岗位要求</h5>
                <ul v-for="require in job.requireList" :key="require">
                  <li>{{ require }}</li>
                </ul>
              </div>
              <p>工作地点：{{ job.address }}</p>
            </div>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import * as api from "../../core/api";
export default {
  name: "job-page",
  data() {
    return {
      list: [],
    };
  },
  async created() {
    const res = await api.get("/api/job/category");
    if (res && res.length) {
      this.list = res.map((item, index) => {
        const jobList = item?.job?.reduce((prev, curr) => {
          const dutyList = curr?.duty?.split("；");
          const requireList = curr?.require?.split("；");
          return [...prev, { ...curr, dutyList, requireList }];
        }, []);
        return {
          ...item,
          jobList,
          isShow: index === 0,
        };
      });
    }
  },
  methods: {
    changItemShow(index) {
      this.list = this.list.map((item, key) => {
        return { ...item, isShow: key === index ? !item.isShow : item.isShow };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#job {
  padding: 10px 16px;
  .list-item {
    margin-bottom: 10px;
    font-size: 16px;
    .item-title {
      background: #f7f8fa;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 5px 20px;
      img {
        width: 16px;
        height: 16px;
      }
    }
    .item-box {
      background: #f7f8fa;
      padding: 16px;
      font-size: 12px;
      .box-top {
        font-size: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #0e81d8;
        img {
          width: 16px;
          height: 16px;
        }
      }
      .job-info {
        border-bottom: 1px solid #cdcdcd;
        padding-bottom: 15px;
        margin-bottom: 10px;
        h4 {
          font-size: 14px;
          color: #666;
          padding: 10px 0;
        }
        .time {
          color: #999;
          margin-bottom: 15px;
        }
        .marg-b-5 {
          padding: 10px 0;
        }
        .jobDesc {
          margin-bottom: 20px;
          li {
            line-height: 22px;
          }
        }
      }
    }
  }
}
</style>